<template>
  <NuxtLayout name="seminar-lp-for1-column">
    <template #title>
      <span style="font-size:1rem;">【法律を学んだ方／法務部員を目指している方／現役法務部員の方／採用ご担当の方】</span>
      <h1>『未完成』こそ法務最強の資質　〜 キャリアは”完成度”より”更新頻度” 〜</h1>
      <v-chip label class="ma-2 webinar-seminar">ウェビナー</v-chip>
      <v-chip label class="ma-2 real-seminar">現地開催</v-chip>
      <v-chip label class="ma-2 hybrid-seminar">ハイブリッド開催</v-chip>
    </template>
    <template #terminated>
      <div v-show="isExpiredApply" style="background-color:#aeaeae;">このセミナーは終了しました</div>
    </template>
    <template #main-visual>
      <v-img width="100%" heghit="100%" :aspect-ratio="960/540" preload contain class="mv mx-auto" :src="`/img/${route.path.replace(/^\//, '')}/mv.webp`" type="image/webp" alt="セミナー">
        <source width="960" heghit="540" :srcset="`/img/${route.path.replace(/^\//, '')}/mv.png, /img/${route.path.replace(/^\//, '')}/mv-2x.png 2x`" type="image/png" />
      </v-img>
      <div class="mx-auto px-3 my-3 mt-6 w-100" style="max-width:480px;">
        <v-btn color="#921639" href="https://t2v91.share.hsforms.com/21dVTeMIyRRanxz6H4jaBDw" target="_blank" v-show="isExpiredApply === false" prepend-icon="fa-solid fa-pen-to-square" text="参加申込をする" rounded="pill" size="x-large" height="4rem" block />
      </div>
    </template>
    <template #detail>
      <p class="heading-4 text-center ma-2" style="font-size:larger;font-weight:bold;">
        「頑張っているのに評価されない」<br />
        「何を直せば伸びるのか分からない」<br />
        「同じ失敗を繰り返してしまう」
      </p>
      <p>
        法務パーソンが詰まる理由の多くは、能力不足ではありません。<br />
        問題は、“成長の仕方”が属人的で、再現できる更新仕様になっていないことです。<br />
        企業法務で伸びる人の差は、知識量やセンスではありません。<br />
        差が出るのは、自分を更新できるか――つまり、<br />
        入力を受け取り（Input＝受信）、原因と次の一手に変換し（Kernel＝処理）、<br />
        日時と適用先を与えて実装し（Deploy＝日時セット）、週次で回して複利化する（Loop＝運用）力です。<br />
      </p>
      <p style="margin-top:1rem;">
        本講演では、「未完成」を弱さではなく、修正可能な余白＝更新資本として使い切るために、成長を再現可能にする“型”をお渡しします。<br />
        ポイントはシンプルです。<br />
      </p>
      <ul style="margin-bottom:1rem;">
        <li>どこで詰まっているか（停止点を特定する“地図”）</li>
        <li>受け取り方（通知を材料に変える“受信仕様”）</li>
        <li>考え方（仮説と次の一手を生む“中心処理”）</li>
        <li>動き方（When/Where/How farで現実に落とす“実装仕様”）</li>
        <li>続け方（週次で回転数を管理し、複利化する“運用設計”）</li>
      </ul>
      <p>
        この型は、環境に依存しません。<br />
      </p>
      <p>
        現職で成果を出し続けたい方にも、転職や役割変化を見据える方にも、「どこに行っても伸びる」ための土台になります。<br />
        明日から使えるチェックリストと、行動に落とすテンプレートもお持ち帰りいただきます。<br />
        <br />
        “仕事ができる”は才能ではなく、更新の総回転数で作れます。
      </p>
      <dl>
        <dt>
          <h3>主催</h3>
        </dt>
        <dd>
          『Attorney's MAGAZINE』編集部<br />
          株式会社C&Rリーガル･エージェンシー社
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>日時</h3>
        </dt>
        <dd>
          2026年3月26日（木） 19:00～20:15<br />
          <ul class="notice">
            <li>
              セミナー終了後に、講師との懇親会も予定しております（要事前申込・抽選制）
            </li>
            <li>
              現地会場および懇親会については、お申込状況等により中止する場合がございます。<br />
              その場合は、オンラインツールでのご視聴をご案内させていただきます。
            </li>
            <li>
              現地会場でのご参加をご希望の方は、<b class="text-decoration-underline">3月16日（月）12:00まで</b>にお申し込みください。
            </li>
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>申込期日</h3>
        </dt>
        <dd>
          現地会場でのご参加の場合：2026年3月16日（月） 12:00まで<br />
          WEBでのご参加の場合：2026年3月26日（木） 17:50まで
          <ul class="notice">
            <li>
              会場の都合等により抽選とさせていただきます。
            </li>
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>参加対象者</h3>
        </dt>
        <dd>
          <ul>
            <li>
              法務部員への就職・転職に関心のある学生・社会人の方
            </li>
            <li>
              法務部員の皆様・企業への転職を目指す弁護士の皆様
            </li>
            <li>
              法務の採用ご担当者様
            </li>
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>会場</h3>
        </dt>
        <dd>
          オンライン（Zoom）＋現地会場（東京都・新橋駅周辺）<br />
          <ul class="notice">
            <li>
              現地会場での聴講をご希望の方につきまして、会場の詳しい場所は、3月19日（木）を目途に当選の方にのみご連絡いたします。<br />
              なお、現地でのご参加枠をご用意できなかった場合には、オンライン視聴用URLを再申込不要でご案内させていただく予定です。
            </li>
            <li>
              当日の参加URLはオンラインセミナー当日までにメールにてお知らせいたします。
            </li>
            <li>
              ご視聴の環境により、セミナーのご視聴ができない可能性がございます。<br />
              その場合、申込完了後のメールに記載しているメールアドレスまでご連絡ください。
            </li>
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>注意事項</h3>
        </dt>
        <dd>
          <ul class="notice">
            <li>同業他社からのお申込はお断りさせていただきます。</li>
            <li>オンライン（Zoom）配信につきましても、お申込者多数の場合は抽選となる可能性がございますのでご了承ください。</li>
            <li>都合によりプログラムの内容・登壇者が変更となる場合がございます。</li>
          </ul>
        </dd>
      </dl>
      <div class="d-none d-md-block mx-auto px-3 my-3 mt-6 w-100" style="max-width:480px;">
        <v-btn color="#921639" href="https://t2v91.share.hsforms.com/21dVTeMIyRRanxz6H4jaBDw" target="_blank" v-show="isExpiredApply === false" prepend-icon="fa-solid fa-pen-to-square" text="参加申込をする" rounded="pill" size="x-large" height="4rem" block />
      </div>
      <h3>登壇者</h3>
      <AppCardSpeakerCard v-for="speaker in speakers" :speaker="speaker" />
    </template>
    <template #form>
    </template>
    <template #floating-navigation>
      <v-fab app extended min-width="13rem" min-height="3rem" color="#921639" location="bottom right" prepend-icon="fa-solid fa-pen-to-square" text="参加申込をする" @click="openForm" v-show="isExpiredApply === false" />
    </template>
  </NuxtLayout>
</template>
<script setup lang="ts">
import type { Speaker } from '@/types/person';
import seminarVar from '@/assets/seminar/202603.json';

const route = useRoute();
const runtimeConfig = useRuntimeConfig();

const eventExpiresApplyDateTime: Date = new Date("2026-03-26T17:50:00.000+09:00");

const isExpiredApply: boolean = (new Date()).getTime() > eventExpiresApplyDateTime.getTime();
const speakers : Speaker[] = ((speakers) => (speakers.map(((speaker) => (
  {
    ...speaker,
    name: `${speaker.name} 氏`,
    image: {
      alt: `講師 ${speaker.name} 氏`,
      proper: {
        src: `/img/${route.path.replace(/^\//, '')}/${speaker.image.filename}.jpg`,
        type: 'image/jpg',
      },
      "2x": {
        src: `/img/${route.path.replace(/^\//, '')}/${speaker.image.filename}-2x.jpg`,
        type: 'image/jpg',
        ratio: "2x",
      },
      webp: {
        src: `/img/${route.path.replace(/^\//, '')}/${speaker.image.filename}.webp`,
        type: 'image/webp',
      },
    },
  }
)))))(seminarVar.speakers);

definePageMeta({
  isr: {
    revalidate: 3600,
  }
});

useHead({
  link: [
    {
      rel: 'preload',
      fetchpriority: "high",
      type: "image/webp",
      href: `/img/${route.path.replace(/^\//, '')}/mv.webp`,
      as: 'image',
    },
    {
      rel: 'canonical',
      href: `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      textContent: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Event",
        "name": "2026年3月セミナー｜【法律を学んだ方／法務部員を目指している方／現役法務部員の方／採用ご担当の方】『未完成』こそ法務最強の資質　〜 キャリアは”完成度”より”更新頻度” 〜",
        "description": "ロースクール生、法務部員を目指す方、キャリアに悩んでいる法務部員の方必見。現役企業法務部長が法務部のキャリアについて語るオンラインキャリアセミナーです。",
        "startDate": "2026-03-26T19:00:00+09:00",
        "endDate": "2026-03-26T20:15:00+09:00",
        "eventAttendanceMode": "https://schema.org/MixedEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "inLanguage": "ja",
        "isAccessibleForFree": true,
        "image": [
          `${runtimeConfig.public.appUrlOrigin}/img/${route.path.replace(/^\//, '')}/mv.png`,
        ],
        "location": [
          {
            "@type": "VirtualLocation",
            "url": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`
          },
          {
            "@type": "Place",
            "name": "東京都新橋駅周辺",
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "日本",
              "addressRegion": "東京都",
              "addressLocality": "港区 新橋駅周辺"
            }
          }
        ],
        "onlineEventUrl": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
        "offers": {
          "@type": "Offer",
          "url": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
          "price": 0,
          "priceCurrency": "JPY",
          "availability": "https://schema.org/InStock"
        },
        "performer": speakers.map(speaker => ({
            "@type": "Person",
            "name": speaker.name,
          })),
        "organizer": {
          "@type": "Organization",
          "name": "C&Rリーガル･エージェンシー社",
          "url": "https://legal-agent.jp/"
        }
      }),
    },
  ],
});
useSeoMeta({
  title: `【法律を学んだ方／法務部員を目指している方／現役法務部員の方／採用ご担当の方】『未完成』こそ法務最強の資質　〜 キャリアは”完成度”より”更新頻度” 〜`,
  description: 'ロースクール生、法務部員を目指す方、キャリアに悩んでいる法務部員の方必見。現役企業法務部長が法務部のキャリアについて語るオンラインキャリアセミナーです。',
  keywords: '企業法務, 法務部 キャリア, 法務職 転職, 法学部 就職先, 法律系 就職, インハウスロイヤー, 法務部 就職活動, 法律職 セミナー, 法務部のリアル, 法律専門職 キャリアセミナー, オンライン法務セミナー',
  ogUrl: `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
  ogTitle: `【法律を学んだ方／法務部員を目指している方／採用ご担当の方】『未完成』こそ法務最強の資質　〜 キャリアは”完成度”より”更新頻度” 〜`,
  ogDescription: 'ロースクール生、法務部員を目指す方、キャリアに悩んでいる法務部員の方必見。現役企業法務部長が法務部のキャリアについて語るオンラインキャリアセミナーです。',
  ogImageUrl: `${runtimeConfig.public.appUrlOrigin}/img/${route.path.replace(/^\//, '')}/mv.png`,
});

const openForm = (() => {
  window.open('https://t2v91.share.hsforms.com/21dVTeMIyRRanxz6H4jaBDw', '_blank')
});
</script>
